const it = {
    langs: {
    }
}

export default it
//意大利


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/it.js